import "../utils/array-polyfills"
import {StringUtil} from "./string-util"

export class Queue{
    constructor(list){
        if(list){
            this._array = list;
            this._done = false;
        }
        else{
            this._array = [];
            this._done = true;
        }
    }

    queue(item){
        this._array.push(item);
        this._done = false;
    }

    dequeue(){
        if(!this._array.length) return null;
        return this._array.shift();
    }

    done(){
        this._done = true;
    }

    get length(){
        return this._array.length;
    }

    get isDone(){
        return this._done;
    }
}

export class Iterator{
    constructor(list, initialPos){
        this._array = list;
        this._pointer = initialPos || 0;
    }

    next(){
        return (this._pointer >= this._array.length) ? null : this._array[this._pointer++];
    }

    peek(){
        return (this._pointer >= this._array.length) ? null : this._array[this._pointer];
    }
}

export class Circular extends Iterator{
    constructor(list, initialPos){
        super(list, initialPos);
    }

    next(){
        let result = this._array[this._pointer++];
        if(this._pointer >= this._array.length) this._pointer = 0;
        return result;
    }

    peek(){
        return this._array[this._pointer];
    }
}

export class SearchList{
    constructor(list){
        this._list = list
        this._length = list.length
        this._start = 0
        this._end = this._length - 1
    }

    binarySearch(compare){
        if(this._end < 0) return null
        const i = Math.floor(this._start + ((this._end - this._start) / 2))
        if(compare.call(this._list, this._list[i]) === 0){
            this._start = 0
            this._end = this._length - 1
            return this._list[i]
        }
        if(this._start === this._end) return null
        else{
            if(compare.call(this._list, this._list[i]) < 0){
                this._start = i + 1
                return this.binarySearch(compare)
            }
            else{
                this._end = i - 1
                return this.binarySearch(compare)
            }
        }
    }
}

export class UniqueList{
    constructor(list){
        this._list = {}
        if(list){
            if(list instanceof Array){
                list.forEach(i => {
                    this._list[StringUtil.hashCode(JSON.stringify(i))] = i
                })
            }
            else{
                return new this.constructor([list])
            }
        }
    }

    get length(){
        return _.keys(this._list).length
    }

    /**
     * If item exists, just don't duplicate
     *
     * @returns {Object} if succeeded, returns the item that was inserted, if failed returns null
     */
    push(item){
        if(this._list[StringUtil.hashCode(JSON.stringify(item))] === undefined){
            this._list[StringUtil.hashCode(JSON.stringify(item))] = item
            return item
        }

        return null
    }

    remove(item){
        delete this._list[StringUtil.hashCode(JSON.stringify(item))]
    }

    /**
     * If item exists, remove item from list
     *
     * @returns {boolean} true if item was included, false if it ws removed
     */
    toggle(item){
        if(!this.push(item)){
            this.remove(item)
            return false
        }

        return true
    }

    toArray(){
        return _.values(this._list)
    }
}